import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'ODS': {
      'TITULO': 'Company profile',
      'TOOLBAR': {
        'NUEVA': 'Create the profile for a company',
        'EDITAR': 'You can modify the profile data of this company',
        'CAMBIOS': '(changes are automatically saved)',
        'DESCARGAR': 'Download company information'
      },
      'FORMULARIOS': {
        '0': 'Company information',
        '1': 'Project manager',
        '2': 'HR director',
        '3': 'IT manager',
      },
      'BOTONES': {
        'BACK': 'Previous',
        'NEXT': 'Next',
        'ACEPTAR': 'Accept'
      },
      'MODALES': {
        'EMPRESA_EXISTE': 'There is already a registered company with the specified name, try to create the company again with another name',
        'ERROR_GUARDADO': 'An error occurred while creating the company, please try again later',
        'GUARDANDO': 'Saving changes',
        'GENERANDO_PDF': 'Generating PDF file, wait a moment'
      },
      'CAMPOS': {
        'institutoEmpresa': 'Broker',
        'country_application': 'Broker country',
        'nombreEmpresa': 'Company',
        'shortName': 'Company short name',
        'nombrePublicacion': 'Company name for publication',
        'account_id': 'Account ID',
        'idSalesForce': 'SalesForce ID',
        'codigoProyecto': 'Project code',
        'anioFundacion': 'Foundation year',
        'empleadosCompleto': 'Full time employees',
        'empleadosParcial': 'Part time employees',
        'totalColaboradores': 'Total number of collaborators',
        'sector': 'Select a sector',
        'subSector': 'Select a sub-sector',
        'multinacional': 'Multinational',
        'name_multinational_group':'Name of multinational group',
        'region': 'Select a region',
        'pais': 'Country',
        'estado': 'State, city or province',

        'nombreResponsable': 'Name',
        'apellidoResponsable': 'Last name',
        'emailResponsable': 'Email',
        'telResponsable': 'Telephone',
        'extResponsable': 'Extension',
        'celResponsable': 'Mobile',

        'nombreRH': 'Full name',
        'emailRH': 'Email',
        'telRH': 'Telephone',
        'extRH': 'Extension',
        'celRH': 'Mobile',

        'nombreTI': 'Full name',
        'emailTI': 'Email',
        'telTI': 'Telephone',
        'extTI': 'Extension',
        'celTI': 'Mobile',

        'PDF_sector': 'Sector',
        'PDF_subSector': 'Subsector',
        'PDF_region': 'Region',
        'PDF_fecha': 'Date:',
        'PDF_hora': 'Hour:',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': 'Yes',
          '2': 'No',
        }
      },
      'ERRORES': {
        'minlength': 'You have not entered the minimum number of characters allowed',
        'maxlength': 'You have exceeded the maximum number of characters allowed',
        'max': 'The number entered exceeds the maximum allowed',
        'min': 'The number entered is less than the minimum required',
        'pattern': 'The text entered contains characters not allowed in this field',
        'email': 'The text entered is not in the correct email format',
        'required': 'This field is required',
        'TEXT_ESPEC_ANIOFUNDA':'The date entered exceeds the maximum allowed',
      }
    }
  }
};
